module.exports = __webpack_public_path__ + "static/media/nordlb.2b14ad45.jpg";